import React from "react";

import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import Stack from "@mui/material/Stack";

const NotificationsContext = React.createContext();

const initialState = {
	open: false,
	message: "",
	severity: "info", //pq el mui llora si no le pongo un valor por defecto
};

const useNotifications = () => {
	const reducer = (state, action) => {
		switch (action.type) {
		case "SHOW_MESSAGE":
			return {
				open: action.open,
				message: action.message,
				severity: action.severity,
			};
		case "CLOSE_MESSAGE":
			return initialState;
		default:
			return state;
		}
	};

	const [state, dispatch] = React.useReducer(reducer, initialState);

	const showMessage = (message, level) => {
		dispatch({
			type: "SHOW_MESSAGE",
			open: true,
			message: message,
			severity: level,
		});
	};
	const closeMessage = () => {
		dispatch({ type: "CLOSE_MESSAGE" });
	};

	return { state, showMessage, closeMessage };
};

const NotificationsSnackbar = ({ notifications }) => {
	const handleClose = (event, reason) => {
		if (reason === "clickaway") {
			return;
		}

		notifications.closeMessage();
	};

	return (
		<Stack spacing={2} sx={{ width: "100%" }}>
			<Snackbar
				open={notifications.state.open}
				autoHideDuration={2500}
				onClose={handleClose}
			>
				<Alert
					onClose={handleClose}
					severity={notifications.state.severity}
					sx={{ width: "100%" }}
				>
					{notifications.state.message}
				</Alert>
			</Snackbar>
		</Stack>
	);
};

export const NotificationsProvider = ({ children }) => {
	const NotificationsObject = useNotifications();

	return (
		<NotificationsContext.Provider value={NotificationsObject}>
			{children}
			<NotificationsSnackbar notifications={NotificationsObject} />
		</NotificationsContext.Provider>
	);
};

export { NotificationsContext };
